import { FC, useMemo } from 'react';
import { LineChartOutlined } from '@ant-design/icons';
import { SumBuyAndSellChartProps } from '../../../../../../core/domain/overview/sum-buy-and-sell';
import { ChartCard } from '../../components/chart-card/chart-card';
import { AreaSeriesChart, CHART_COLORS, faNumber, mergeByDate, sumOf } from '../chart-commons';

interface Props {
    chartData: SumBuyAndSellChartProps;
    chartLoading: boolean;
}

const series = [
    { key: 'buys', name: 'خرید', color: CHART_COLORS.green },
    { key: 'sells', name: 'فروش', color: CHART_COLORS.red },
];

export const SumBuyAndSell: FC<Props> = ({ chartData, chartLoading }) => {
    const data = useMemo(
        () =>
            mergeByDate([
                { key: 'buys', data: chartData?.buys },
                { key: 'sells', data: chartData?.sells },
            ]),
        [chartData],
    );

    return (
        <ChartCard
            title="مجموع خرید و فروش ها"
            subtitle="مبلغ کل سفارش‌های خرید و فروش"
            icon={<LineChartOutlined />}
            accent="blue"
            loading={chartLoading}
            empty={!data.length}
            stats={[
                { label: 'خرید', value: faNumber(sumOf(data, 'buys')), color: CHART_COLORS.green },
                { label: 'فروش', value: faNumber(sumOf(data, 'sells')), color: CHART_COLORS.red },
            ]}
        >
            <AreaSeriesChart data={data} series={series} />
        </ChartCard>
    );
};
